<template>
  	<BillingAccountList />
</template>

<script>

// @ is an alias to /src
import BillingAccountList from "@/components/BillingAccountList.vue";

export default {
  name: "BillingAccountLists",
  components: {
    BillingAccountList,
  },
};
</script>
